import firebaseSecondary from 'firebaseSecondary';
import defaultActions from './default';
import { disableUser } from '../api/hdrainClient';

const ENTITIES = 'USERS';
const ENTITY = 'USER';
const Entity = 'User';
const entityName = 'user';
const ENTITIES_COLLECTION = 'users';

const usersActions = defaultActions({
  ENTITIES,
  ENTITY,
  Entity,
  entityName,
  ENTITIES_COLLECTION,
});
export const { ACTIONS_NAMES_DICT } = usersActions;

export const { ENTITY_ACTIONS } = usersActions;
export const { fetchEntities } = usersActions;

const createEntityPreCall = async (entityData) => {
  const { email, password } = entityData;

  const response = await firebaseSecondary
    .auth()
    .createUserWithEmailAndPassword(email, password);

  const { uid } = response.user;

  // User data without password
  const clonedEntity = { ...entityData, id: uid };
  delete clonedEntity.password;
  return clonedEntity;
};

export const createEntity = (entityData) => {
  return usersActions.createEntity(entityData, createEntityPreCall);
};

export const { updateEntity } = usersActions;

export const archiveEntity = (entityId) => {
  return usersActions.archiveEntity(entityId, () => {
    // Disable user with a firebase function
    return disableUser(entityId);
  });
};
export const { entitiesCleanUp } = usersActions;
export const { clearEntitiesDataLogout } = usersActions;
